// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"App_sectionWrapper__3VpMc"};